<template>
  <div class="find">
    <div class="find-upper com-padding-top-70 com-padding-bottom-90">
      <div class="com-content-1340">
        <div class="dn-upper text-align-center">
          <div class="com-title1">Group headquarters</div>
          <div class="com-line1"></div>
        </div>
        <div class="dn-center com-padding-top-50">
          If you are interested in cooperating with us, please contact us through the following ways:
        </div>
        <div class="dn-lower com-padding-top-30">
          <div class="swiper-container swiper1">
            <div class="swiper-wrapper wrapper1">
              <div class="swiper-slide slide1">
                <div class="dp-picture">
                  <i class="iconfont icon-youxiang1"></i>
                </div>
                <div class="dp-word">
                  <div class="dp-p1">Mailbox</div>
                  <div class="dp-p2">{{ dataDetail.email }}</div>
                </div>
              </div>
              <div class="swiper-slide slide1">
                <div class="dp-picture">
                  <i class="iconfont icon-telephone3"></i>
                </div>
                <div class="dp-word">
                  <div class="dp-p1">Customer service telephone numbers</div>
                  <div class="dp-p2">{{ dataDetail.kefu_tel }}</div>
                </div>
              </div>
              <div class="swiper-slide slide1">
                <div class="dp-picture">
                  <i class="iconfont icon-jianzhu"></i>
                </div>
                <div class="dp-word">
                  <div class="dp-p1">Headquarters address</div>
                  <div class="dp-p2">{{ dataDetail.address }}</div>
                </div>
              </div>
              <div class="swiper-slide slide1">
                <div class="dp-picture">
                  <img :src="stateimgBaseURL+dataDetail.imga_path"
                       alt="" class="dp-img1 com-size-all com-object-fit-cover">
                </div>
                <div class="dp-word">
                  <div class="dp-p2">
                    Mobile phone scanning QR code <br>
                    Add crown wechat official account<br>
                    Keep up with the latest developments of crown
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="find-lower com-padding-bottom-90">
      <div class="com-content-1340">
        <div class="dn-upper text-align-center">
          <div class="com-title1">Dealer outlets</div>
          <div class="com-line1"></div>
        </div>
        <div class="dn-center com-padding-top-50">
          <el-form
              :model="ruleForm" ref="ruleForm" class="el-form1">
            <el-form-item prop="pronvice_id">
              <el-select
                  filterable v-model="ruleForm.pronvice_id" style="width: 100%;"
                  placeholder="Please select a province" @change="changeSelect(2)">
                <el-option
                    v-for="item in dataSelectPronvice" :key="item.id"
                    :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="city_id">
              <el-select
                  filterable v-model="ruleForm.city_id" style="width: 100%;"
                  placeholder="Please select a city" @change="changeSelect(3)">
                <el-option
                    v-for="item in dataSelectCity" :key="item.id"
                    :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="area_id">
              <el-select
                  filterable v-model="ruleForm.area_id" style="width: 100%;"
                  placeholder="Please select an area">
                <el-option
                    v-for="item in dataSelectArea" :key="item.id"
                    :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="keywords">
              <el-input v-model="ruleForm.keywords" placeholder="Please enter keywords"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button @click="submitForm('ruleForm')" class="el-button1">Submit information</el-button>
            </el-form-item>
          </el-form>
        </div>
        <div class="dn-lower com-padding-top-50">
          <div class="swiper-container swiper1">
            <div class="swiper-wrapper wrapper1">
              <div class="swiper-slide slide1"
                   v-for="(item, index) in dataSwiper" :key="index"
                   @click="clickMap(item)" :class="{'router-link-active':item.shop_id==currentSwitch}">
                <div class="dn-zuo">
                  <b>{{ index + 1 }}</b>
                  <i class="iconfont icon-drip-full"></i>
                </div>
                <div class="dn-you">
                  <div class="dp-name1">{{ item.title }}</div>
                  <div class="dp-addr1">{{ item.address }}</div>
                  <div class="dp-phone1">{{ item.online }}</div>
                </div>
              </div>
            </div>
            <div class="swiper-button-parent">
              <div class="swiper-button swiper-prev">
                <i class="el-icon-arrow-left"></i>
              </div>
              <div class="swiper-button swiper-next">
                <i class="el-icon-arrow-right"></i>
              </div>
            </div>

          </div>
        </div>
        <div class="dn-map com-padding-top-50" v-if="mapPoint">
          <div id="allmap" class="allmap" ref="allmap"></div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import Swiper from 'swiper'
import {mapState} from "vuex";

export default {
  data() {
    return {
      dataDetail: '',
      dataSelectPronvice: [],
      dataSelectCity: [],
      dataSelectArea: [],
      dataSwiper: [],
      currentSwitch: '',
      mapPoint: '',
      ruleForm: {
        city_type: '1',//1-获取省，2-获取市，3-获取区
        pronvice_id: '',//省id（获取市，区必上传）
        city_id: '',//市id (获取区上传)
        area_id: '',//区域id
        keywords: '',
      },
    }
  },
  computed: {
    ...mapState(['stateimgBaseURL'])
  },
  created() {
    this.dataRequestusercenter_findGroup()
    this.dataRequestbasis_getCity()
  },
  mounted() {

  },
  methods: {
    // GET如何找到我们-集团总部
    dataRequestusercenter_findGroup() {
      this.$api.user.usercenter_findGroup().then(res => {
        this.dataDetail = res.data.info
      })
    },

    // GET获取城市
    dataRequestbasis_getCity() {
      let params = {
        ...this.ruleForm,
      }
      this.$api.user.basis_getCity(params).then(res => {
        if (this.ruleForm.city_type == 1) {
          this.dataSelectPronvice = res.data.list
        } else if (this.ruleForm.city_type == 2) {
          this.ruleForm.city_id = ''
          this.ruleForm.area_id = ''
          this.dataSelectArea = []
          this.dataSelectCity = res.data.list
        } else if (this.ruleForm.city_type == 3) {
          this.ruleForm.area_id = ''
          this.dataSelectArea = res.data.list
          console.log(this.dataSelectArea)
        }
      })
    },
    changeSelect(item) {
      this.ruleForm.city_type = item
      this.dataRequestbasis_getCity()
    },

    methodsMap() {
      console.log('mapPoint2:', this.mapPoint)
      let longlati = this.mapPoint.split(",");
      let long = longlati[0];
      let lati = longlati[1];
      let map = new BMapGL.Map(this.$refs.allmap);
      let point = new BMapGL.Point(long, lati);
      map.centerAndZoom(point, 18)
      map.enableScrollWheelZoom(true);
      let marker1 = new BMapGL.Marker(new BMapGL.Point(long, lati));
      map.addOverlay(marker1);
    },
    initSwiperHomeprod() {
      let mySwiperHomeprod = new Swiper('.find-lower .dn-lower .swiper1', {
        observer: true,
        observeParents: true,
        autoHeight: true,
        slidesPerView: 'auto',
        navigation: {
          nextEl: '.find-lower .dn-lower .swiper-next',
          prevEl: '.find-lower .dn-lower .swiper-prev',
        },
      });
    },
    clickMap(item) {
      this.mapPoint = item.map
      this.currentSwitch = item.shop_id
      this.methodsMap()
    },
// GET如何找到我们-经销商网点
    dataRequestusercenter_dealerOutlets() {
      let params = {
        ...this.ruleForm,
      }
      this.$api.user.usercenter_dealerOutlets(params).then(res => {
        this.dataSwiper = res.data.list
        if (this.dataSwiper.length > 0) {
          this.currentSwitch = this.dataSwiper[0].shop_id
          this.mapPoint = this.dataSwiper[0].map
          console.log('mapPoint:', this.mapPoint)
          this.$nextTick(() => {
            this.initSwiperHomeprod()
            this.methodsMap()
          })
        }
      })
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.dataRequestusercenter_dealerOutlets()
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
  }
}
</script>

<style scoped lang="scss">
.find-upper {
  .dn-lower {
    .swiper1 {
      overflow: visible;

      .wrapper1 {
        justify-content: space-between;
      }

      .slide1 {
        width: calc(100% / 4 - 3%);
        box-shadow: 0 0 5px rgba(0, 0, 0, .3);
        border-radius: 8px;
        height: auto;
        text-align: center;
        padding: 50px;
        transition: all .3s ease;

        &:hover {
          transform: translateY(-10px);
          box-shadow: 0 0 15px rgba(0, 0, 0, .3);
        }

        .dp-picture {
          width: 105px;
          height: 105px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: auto;
          color: $color1;

          i {
            font-size: 70px;
          }
        }

        .dp-word {
          font-size: 13px;

          .dp-p1 {
            color: #b5b3b3;

          }

          .dp-p2 {
            color: #424542;
            line-height: 24px;
            margin: 15px 0 0;
          }
        }
      }
    }
  }
}

.find-lower {
  .dn-center {
    .el-form1 {
      padding: 20px;
      background: rgba(0, 0, 0, .6);
      display: flex;
      align-items: center;

      .el-form-item {
        margin: 0 5px;

        &:not(:last-of-type) {
          flex: 1;
        }
      }

      .el-button1 {
        background: $color2;
        color: #ffffff;
        border: none;
      }
    }
  }

  .dn-lower {
    .swiper1 {
      padding: 0 30px;

      .swiper-button-parent {
        .swiper-button {
          position: absolute;
          top: 50%;
          transform: translate(0, -50%);
          cursor: pointer;

          i {
            font-size: 30px;
          }
        }

        .swiper-prev {
          left: 0;
        }

        .swiper-next {
          right: 0;
        }
      }

      .slide1 {
        width: calc(100% / 3);
        border-right: 1px solid $line1;
        display: flex;
        align-items: flex-start;
        padding: 0 55px 45px;
        cursor: pointer;

        &.router-link-active {
          .dn-you {
            color: $color2;
          }
        }

        .dn-zuo {
          position: relative;
          margin: 0 5px 0 0;

          b {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -60%);
            color: #ffffff;
          }

          i {
            font-size: 30px;
            color: $color2;
          }
        }

        .dn-you {
          font-size: 16px;
          line-height: 28px;
          flex: 1;

          .dp-name1 {
            color: #333333;
            font-size: 20px;
            margin: 0 0 6px;
          }
        }
      }
    }
  }

  .dn-map {
    .allmap {
      height: 630px;
    }
  }

}

@media screen and (max-width: 768px) {
  .find-upper {
    .dn-lower {
      .swiper1 {
        .wrapper1 {
          flex-wrap: wrap;
        }

        .slide1 {
          width: calc(100% / 2 - 3%);
          margin: calc(3% / 2);
          padding: 50*$mobile-conversion;

          .dp-picture {
            width: 110*$mobile-conversion;
            height: 110*$mobile-conversion;

            i {
              font-size: 80*$mobile-conversion;
            }
          }

          .dp-word {
            font-size: 23*$mobile-conversion;

            .dp-p2 {
              margin: 15*$mobile-conversion 0 0;
            }
          }
        }
      }
    }
  }
  .find-lower {
    .dn-center {
      .el-form1 {
        padding: 20*$mobile-conversion;
        flex-wrap: wrap;

        .el-form-item {
          margin: 10*$mobile-conversion 1%;
          width: calc(100% / 2 - 2%);
          &:not(:last-of-type) {
            flex: inherit;
          }
        }
      }
    }

    .dn-lower {
      .swiper1 {
        padding: 0 30*$mobile-conversion;

        .swiper-button-parent {
          .swiper-button {
            i {
              font-size: 30*$mobile-conversion;
            }
          }
        }

        .slide1 {
          width: calc(100% / 2);
          padding: 0 15*$mobile-conversion 10*$mobile-conversion;

          .dn-zuo {
            margin: 0 5*$mobile-conversion 0 0;

            i {
              font-size: 36*$mobile-conversion;
            }
          }

          .dn-you {
            font-size: 26*$mobile-conversion;
            line-height: 40*$mobile-conversion;
            .dp-name1 {
              font-size: 28*$mobile-conversion;
              margin: 0 0 10*$mobile-conversion;
            }
          }
        }
      }
    }

    .dn-map {
      .allmap {
        height: 500*$mobile-conversion;
      }
    }

  }
}
</style>
